export const SKILL_LIBRARY_SEGMENT = "/agent/skills";

export const SKILL_LIBRARY_PATH = `/settings${SKILL_LIBRARY_SEGMENT}`;

export const CUSTOM_SKILL_PATH = `${SKILL_LIBRARY_PATH}/custom`;

export const ROUTINES_PATH = "/settings/agent/routines";
